<template>
  <div v-if="element" :class="`${element.compData.type}-theme-${element.compData.styleId}`" :style="{...getStyles(element.compData.styles),
    width: element.width + 'px',
    height: element.height + 'px',}">
    <RadioGroup v-model="element.compData.activeIndex" vertical @on-change="handleClick">
      <Radio v-for="(item, index) in element.compData.menus" :key="item.id" :label="index" :class="element.compData.styleId === 1 ? 'radio-right' : ''">
        <span class="radio-title">{{ item.name }}</span>
      </Radio>
    </RadioGroup>
  </div>
</template>

<script>
// iview
import { RadioGroup, Radio } from "view-design";
import "view-design/dist/styles/iview.css";

export default {
  name: "CompTable",
  props: {
    element: {
      type: Object,
      default: null,
      require: true,
    },
  },
  components: {
    RadioGroup,
    Radio,
  },
  data: () => {
    return {
      loading: true,
    };
  },
  computed: {
    plugin: function () {
      return this.$getPlugin(this.element.id);
    },
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1234);
    this.element.compData.activeIndex = this.element.compData.defaultActiveIndex
    this.$blueMap.trigger({
      nodeType: "plugin",
      pluginId: this.element.id,
      dataKey: "onmounted",
      eventData: {
        value: this.element.compData.menus[this.element.compData.activeIndex],
        data: this.plugin,
        event: null,
      },
    });
  },
  methods: {
    handleClick(activeIndex) {
      const item = this.element.compData.menus[activeIndex] || null;
      item &&
        this.$blueMap.trigger({
          nodeType: "plugin",
          pluginId: this.plugin.id,
          dataKey: "onclick",
          eventData: {
            value: item,
            data: this.plugin,
            event: null,
          },
        });
    },
    getStyles(styles) {
      if (!styles) return;
      const res = {};
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] =
          typeof styles[item] === "number" ? styles[item] + "px" : styles[item];
      });
      return res;
    },
  },
};
</script>

<style lang='less' scoped>
/deep/ .ivu-radio-group {
  width: 100%;
}
/deep/ .ivu-radio-group-vertical {
  .ivu-radio-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: var(--fontSize);
    font-family: var(--fontFamily) !important;
    margin-bottom: var(--marginBottom);
    &.radio-right {
      .ivu-radio {
        order: 1;
      }
    }
    .radio-title {
      color: var(--color);
    }
  }
}
/deep/ .ivu-radio-inner {
  background-color: var(--radioBg);
  border-color: var(--radioBorderColor);
  width: var(--radioSize);
  height: var(--radioSize);
  &:after {
    width: calc(var(--radioSize) - 6px);
    height: calc(var(--radioSize) - 6px);
    border-radius: 50%;
    background-color: var(--radioActiveColor);
  }
}
/deep/.ivu-radio-checked .ivu-radio-inner {
  border-color: var(--radioActiveColor);
  background-color: transparent;
}
</style>
